import { Text } from "@/elements"
import { ChevronDownIcon } from "@/icons/outline"
import * as Popover from "@radix-ui/react-popover"
import { IconButton } from "../IconButton"
import clsx from "clsx"
import adjustDateForTimezone from "@/utils/dates"

export const YearPicker = ({ changeYear, date }: { changeYear: (string: number) => void; date: Date }) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <IconButton Icon={ChevronDownIcon} size="small" />
      </Popover.Trigger>
      <Popover.Anchor />

      <Popover.Content className="z-[101]">
        <div className="flex flex-col gap-y-2 overflow-hidden rounded-xl border border-bg-3 bg-bg-1 shadow-lg">
          <div className="flex max-h-[200px] w-[120px] flex-col gap-y-1 overflow-y-auto px-1 pt-1">
            {Array.from({ length: 100 }, (_, i) => {
              const year = adjustDateForTimezone(new Date().toISOString())?.getFullYear()! - i
              return (
                <div
                  key={year}
                  onClick={() => changeYear(year)}
                  className={clsx(
                    "w-full cursor-pointer rounded-md px-3 py-1 text-left hover:bg-bg-2",
                    date.getFullYear() === year && "bg-bg-3"
                  )}>
                  <Text className="text-center">{year}</Text>
                </div>
              )
            })}
          </div>
          <div className="flex flex-row items-center justify-center">
            <ChevronDownIcon className="size-3 stroke-fg-2" />
          </div>
        </div>
      </Popover.Content>
    </Popover.Root>
  )
}
